import React, { useState } from 'react';
import { fromRole, getProfileHeightString, getProfileWeightString, humanize, ProfileStatusMaster, ProjectModel, SbCurrentUser } from '../component/SbModel';
import SbProfileSelector from '../SbProfileSelector';
import SbShortlistAddNote from '../component/SbShortlistAddNote';
import { CircleMinus,Plus,CircleUserRound, SquareUserIcon, MinusIcon, PlusIcon, HeartIcon } from 'lucide-react';

import submissionBoardService from '../../services/SubmissionBoardService';
import { showToast } from '../../shared/Toast';
import TooltipElement from '../../shared/TooltipElement';

import defaultProjectPlaceHolder from '../../../assets/images/project_placeholder@2x.jpg';
import { ProfileDetailView } from '../../profiles/ProfileViews';

interface SbProfileItemProps {
  currentUser: SbCurrentUser;
  indexRow: number;
  submissionBoardModel: any;
  project: ProjectModel;
  user: any;
  from: string;
  sb_recipient?: any;
  profileIndex: number;
  // prevNextProfile?: (value: number, profileIndex: number) => void;
  profileSelected?: (profileInfo: any) => void;
}
// component to show profile photo/age/weight/height
// used by SbDetails and SbDetailsRecipient
export const SbProfileItem: React.FC<SbProfileItemProps> = ({
  indexRow,
  currentUser,
  submissionBoardModel,
  project,
  user,
  from,
  sb_recipient,
  profileIndex,
  // prevNextProfile,
  profileSelected,
}) => {
  const [showProfileSelector, setShowProfileSelector] = useState(false);
  const [imageSrc, setImageSrc] = useState(user.croppedAvatarUrl || defaultProjectPlaceHolder);
  const [profileModalUser, setprofileModalUser] = useState(null);

  const getProfileStatusBorder = () => {
    if ( user?.sb_profiles && user.sb_profiles.length > 0) {
      if (user.sb_profiles[0].profile_status == ProfileStatusMaster.Selected) {
        return 'border-green-400';
      } else if (user.sb_profiles[0].profile_status == ProfileStatusMaster.Rejected) {
        return 'border-red-400';
      }
    }
    return '';
  };
  const addToBoardClickHandler = () => {
    console.log('showProfileSelector', showProfileSelector);
    setShowProfileSelector(true);
  };

  const removeFromBoardClickHandler = async () => {
    try {
      await submissionBoardService.removePerformerFromSubmissionBoard(
        project.uuid,
        submissionBoardModel.id,
        user.id
      );
      showToast('Profile removed from board', 'success');
      // Call profileSelected to update the parent component
      if (profileSelected) {
        await profileSelected({
          project_id: project.uuid,
          submission_board_id: submissionBoardModel.id,
          profile_id: user.id,
          action: 'removed'
        });
      }
    } catch (error) {
      console.error('Error removing profile from board:', error);
      showToast('Failed to remove profile from board', 'danger');
    }
  };

  const isProfileInBoard = () => {
    return user.is_in_board || (user.sb_profiles && user.sb_profiles.length > 0);
  };
  return (
    <div
      className={
        'flex flex-1 flex-col bg-white rounded-xl border border-gray-300 p-4 shadow-md' +
        getProfileStatusBorder()
      }
    >
      {/* <a
        target={from == fromRole.SB_CREATOR ? '_blank' : ''}
        onClick={(event: React.MouseEvent) => {
          console.log('Shortlist clicked for user A:');
          if (from == fromRole.RECIPIENT) {
            // if (prevNextProfile) {
            //   prevNextProfile(0, profileIndex);
            // }
          }
        }}
      > */}
        <div className="flex flex-1 flex-col h-full">
          <div className="user-avatar h-0 flex flex-none w-full relative">
            <img
              className="absolute top-0 d-block ml-auto mr-auto w-full h-full object-cover"
              src={imageSrc}
              onError={() => setImageSrc(defaultProjectPlaceHolder)}
              draggable="false"
            />
            {from == fromRole.RECIPIENT &&
              user?.sb_profiles &&
              user.sb_profiles?.length > 0 &&
              user.sb_profiles[0].profile_status == ProfileStatusMaster.Selected && (
                <div className="absolute flex justify-center top-0 right-0">
                  <div className="flex rounded bg-green-200  px-1 py-1 text-xs font-semibold tabular-nums text-gray-700">
                    Selected
                  </div>
                </div>
              )}
            {from == fromRole.RECIPIENT &&
              user?.sb_profiles &&
              user.sb_profiles?.length > 0 &&
              user.sb_profiles[0].profile_status == ProfileStatusMaster.Rejected && (
                <div className="absolute flex justify-center top-0 right-0">
                  <div className="flex rounded bg-red-200 px-1 py-1 text-xs font-semibold tabular-nums text-gray-700">
                    Not Selected
                  </div>
                </div>
              )}
          </div>
          <div className="flex flex-grow mt-auto items-start">
            <div className="w-full text-xs font-normal flex flex-col">
              <div className="w-full flex justify-center items-center" style={{ minHeight: '2.5rem' }}>
                <span className="block break-all text-base truncate font-semibold  px-1 pb-1 pt-2">
                  {user.firstName} {user.lastName}
                </span>
                {user.is_fav && <div className='w-3 h-3 items-center flex' style={{
                  color: '#8570E4'
                }}>
                  <HeartIcon fill="#8F79F1B2" className='w-3 h-3'/>
                </div> }
              </div>
              <div className="flex flex-col gap-1 pt-1 pb-3 justify-center items-center" style={{ minHeight: '5.5rem' }}>
                <div className="flex flex-row justify-center items-center ">
                  <div className="flex items-center justify-center flex-1  text-center">
                    {humanize(user.gender)}
                    {' . '}
                    {user.ethnicities && user.ethnicities.length > 0
                      ? humanize(user.ethnicities.join(', '))
                      : ''}
                  </div>
                </div>
                <div className="flex flex-row  justify-center items-center ">
                  <div className="flex items-center justify-center flex-1  text-center">
                    {user.hair_make_up_kit != null && user.hair_make_up_kit.hair_color
                      ? humanize(user.hair_make_up_kit.hair_color + ' hair')
                      : ''}
                    {' - '}
                    {user.hair_make_up_kit != null && user.hair_make_up_kit.eye_color
                      ? humanize(user.hair_make_up_kit.eye_color + ' eyes')
                      : ''}
                  </div>
                </div>
                <div className="flex flex-row  justify-center items-center  text-center">
                  <div className="flex items-center justify-center flex-1">
                    {getProfileHeightString(user, currentUser)}
                    {' . '}
                    {getProfileWeightString(user, currentUser)}
                  </div>
                </div>
              </div>

              {from == fromRole.SB_CREATOR && (
                <div className="flex flex-row gap-1 px-1 text-sm text-gray-700 justify-center items-center ">
                  <div className="flex flex-row items-center py-1">
                    <TooltipElement message={'View profile'} width=' w-40 max-w-xs '>
                    {/* <a
                      className="gap-1 flex flex-row justify-center items-center font-semibold cursor-pointer hover:text-blue-800"
                      target={from == fromRole.SB_CREATOR ? '_blank' : ''}
                      href={
                        from == fromRole.SB_CREATOR
                          ? `/users/${user.uuid}?from=sb&project_id=${project.uuid}&sb_id=${submissionBoardModel.id}`
                          : null
                      }
                    > */}
                    <div
                      className="gap-1 flex flex-row justify-center items-center font-semibold cursor-pointer hover:text-blue-800"
                      onClick={() => {
                        setprofileModalUser(user);
                      }}
                    > 
                      <div className='flex flex-row items-center w-8 h-8 border border-gray-300flex flex-row items-center w-8 h-8 rounded-full border border-gray-300 justify-center'>
                        <SquareUserIcon className="h-5 w-5" aria-hidden="true" />
                      </div>
                      {/* <div>View profile</div> */}
                    </div>
                    </TooltipElement>
                  </div>
                  <div className="flex flex-row items-center py-1">
                    {isProfileInBoard() ? (
                      <TooltipElement message={'Remove from Board'} width=' w-40 max-w-xs '>
                      <div
                        id={'removefromboard_' + indexRow}
                        onClick={() => {
                          removeFromBoardClickHandler();
                        }}
                        className="gap-1 flex flex-row justify-center items-center font-semibold cursor-pointer hover:text-red-800"
                      >
                         <div className='flex flex-row items-center w-8 h-8 border border-gray-300flex flex-row items-center w-8 h-8 rounded-full border border-gray-300 justify-center'>
                          <MinusIcon className="h-5 w-5" aria-hidden="true" />
                        </div>
                        {/* <div>Remove from Board</div> */}
                      </div>
                      </TooltipElement>
                    ) : (
                      <TooltipElement message={'Add to Board'} width=' w-40 max-w-xs '>
                      <div
                        id={'addtoboard_' + indexRow}
                        onClick={() => {
                          addToBoardClickHandler();
                        }}
                        className="gap-1 flex flex-row justify-center items-center font-semibold cursor-pointer hover:text-blue-800"
                      >
                        <div className='flex flex-row items-center w-8 h-8 border border-gray-300flex flex-row items-center w-8 h-8 rounded-full border border-gray-300 justify-center'>
                        <PlusIcon className="h-5 w-5" aria-hidden="true" />
                      </div>
                        {/* <Plus className="h-4 w-4" aria-hidden="true" /> */}
                        {/* <div>Add to Board</div> */}
                      </div>
                      </TooltipElement>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      {/* </a> */}

      {profileModalUser != null && (<ProfileDetailView user={profileModalUser} 
        currentUser={currentUser} 
        userUuid={profileModalUser.uuid}
        project_id ={project.uuid}
        link_from={'sb'}
        sb_id={submissionBoardModel.id}        
        onClose={() =>{
          setprofileModalUser(null);
        }} 
       />)}
      {showProfileSelector && (
        <SbShortlistAddNote
          currentUser={currentUser}
          user={user}
          submissionBoardModel={submissionBoardModel}
          project={project}
          from="sbprofile"
          dialogCloseHandler={() => {
            setShowProfileSelector(false);
          }}
          profileSelected={async (profileInfo: any) => {
            if (profileSelected) {
              await profileSelected(profileInfo);
            }
          }}
        ></SbShortlistAddNote>
      )}
    </div>
  );
};
